import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Header from "@/components/main/Header";
import Banner from "@/components/learn/Banner";
import Items from "@/components/learn/Items";
import YoutubeSlick, { type TYoutubeItem } from "@/components/learn/YoutubeSlick";
import EcoSystem from "@/components/products/detail/EcoSystem";
import OtherModels from "@/components/products/detail/OtherModels";
import ContactUs from "@/components/contact-us";
import Footer from "@/components/main/Footer";
import { TApplicationData, TEcoSystemGuide } from "@/typings/Props";

const EcoSystemWrap = styled.div`
  background-color: #fff;
  margin: 30px 0;
  padding: 30px 0;
`;

const YoutubeSlickWrap = styled.div`
  background-color: #fff;
  margin: 50px 0;
  padding: 50px 0;
`;

export default function Home() {
  const { t } = useTranslation();

  const items: TApplicationData[] = [
    {
      id: 1,
      title: t("menu.learn.corporate.item.title-1"),
      desc: t("menu.learn.corporate.item.desc-1"),
      iconPath: "/learn/application/Employee-Health-Improvement.svg",
    },
    {
      id: 2,
      title: t("menu.learn.corporate.item.title-2"),
      desc: t("menu.learn.corporate.item.desc-2"),
      iconPath: "/learn/application/Health-Claims-Prevention.svg",
    },
    {
      id: 3,
      title: t("menu.learn.corporate.item.title-3"),
      desc: t("menu.learn.corporate.item.desc-3"),
      iconPath: "/learn/application/Customer-Retention.svg",
    },
  ];

  const ecoSystem: TEcoSystemGuide[] = [
    {
      id: "+",
      title: t("menu.learn.fitness.ecosystem-1.title"),
      desc: t("menu.learn.fitness.ecosystem-1.desc"),
      coord: {
        x: "18.5%",
        y: "10.6%",
      },
    },
    {
      id: "+",
      title: t("menu.learn.fitness.ecosystem-2.title"),
      desc: t("menu.learn.fitness.ecosystem-2.desc"),
      coord: {
        x: "29%",
        y: "38%",
      },
    },
    {
      id: "+",
      title: t("menu.learn.fitness.ecosystem-3.title"),
      desc: t("menu.learn.fitness.ecosystem-3.desc"),
      coord: {
        x: "46%",
        y: "33%",
      },
    },
    {
      id: "+",
      title: t("menu.learn.fitness.ecosystem-4.title"),
      desc: t("menu.learn.fitness.ecosystem-4.desc"),
      coord: {
        x: "44%",
        y: "52%",
      },
    },
    {
      id: "+",
      title: t("menu.learn.fitness.ecosystem-5.title"),
      desc: t("menu.learn.fitness.ecosystem-5.desc"),
      coord: {
        x: "50%",
        y: "74.5%",
      },
    },
    {
      id: "+",
      title: t("menu.learn.fitness.ecosystem-6.title"),
      desc: t("menu.learn.fitness.ecosystem-6.desc"),
      coord: {
        x: "43.8%",
        y: "86.6%",
      },
    },
    {
      id: "+",
      title: t("menu.learn.fitness.ecosystem-7.title"),
      desc: t("menu.learn.fitness.ecosystem-7.desc"),
      coord: {
        x: "61.5%",
        y: "47.9%",
      },
    },
    {
      id: "+",
      title: t("menu.learn.fitness.ecosystem-8.title"),
      desc: t("menu.learn.fitness.ecosystem-8.desc"),
      coord: {
        x: "68.8%",
        y: "65.3%",
      },
    },
    {
      id: "+",
      title: t("menu.learn.fitness.ecosystem-9.title"),
      desc: t("menu.learn.fitness.ecosystem-9.desc"),
      coord: {
        x: "82.4%",
        y: "53.2%",
      },
    },
  ];

  const youtubeItems: TYoutubeItem[] = [
    {
      title: t("menu.learn.corporate.youtube-item-1.title"),
      src: "https://www.youtube.com/embed/57GAJ_3R1Zg?feature=oembed&enablejsapi=1&origin=https://inbodyasia.com",
      descSubTitle: t("menu.learn.corporate.youtube-item-1.desc.sub-title"),
      descTitle: t("menu.learn.corporate.youtube-item-1.desc.title"),
      desc: t("menu.learn.corporate.youtube-item-1.desc.desc"),
    },
    {
      title: t("menu.learn.corporate.youtube-item-2.title"),
      src: "https://www.youtube.com/embed/Bn2IsXz7GLM?feature=oembed&enablejsapi=1&origin=https://inbodyasia.com",
      descSubTitle: t("menu.learn.corporate.youtube-item-2.desc.sub-title"),
      descTitle: t("menu.learn.corporate.youtube-item-2.desc.title"),
      desc: t("menu.learn.corporate.youtube-item-2.desc.desc"),
    },
    {
      title: t("menu.learn.corporate.youtube-item-3.title"),
      src: "https://www.youtube.com/embed/dL1OL0e_c-c?feature=oembed&enablejsapi=1&origin=https://inbodyasia.com",
      descSubTitle: t("menu.learn.corporate.youtube-item-3.desc.sub-title"),
      descTitle: t("menu.learn.corporate.youtube-item-3.desc.title"),
      desc: t("menu.learn.corporate.youtube-item-3.desc.desc"),
    },
  ];

  return (
    <>
      <Header />
      <Banner
        Bg="/learn/banner/applicatipon-corporate-bg.png"
        Headline={t("menu.learn.banner.headline")}
        Title={t("menu.learn.corporate.banner.title")}
        Desc={t("menu.learn.corporate.banner.desc")}
      />

      <Items
        title={t("menu.learn.corporate.item.main-title")}
        titleCaption={t("menu.learn.corporate.item.main-title-caption")}
        desc={t("menu.learn.corporate.item.main-desc")}
        items={items}
      />

      <YoutubeSlickWrap>
        <YoutubeSlick youtubeItems={youtubeItems} />
      </YoutubeSlickWrap>

      <EcoSystemWrap>
        <EcoSystem
          ecoImg={"/learn/application/Health-Corner-580-Medical-new.webp"}
          title={t("menu.learn.corporate.ecosystem.title")}
          desc={t("menu.learn.corporate.ecosystem.desc")}
          ecoSystem={ecoSystem}
        />
      </EcoSystemWrap>
      <OtherModels />
      <div style={{ margin: "50px 0 0 0" }} />
      <ContactUs />
      <Footer />
    </>
  );
}
